import * as z from 'zod';

export const meetingSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  company: z.string().min(1, 'Company is required'),
  phone_number: z.string().min(1, 'Phone Number is required'),
  email_address: z.string().email('Invalid email address'),
  state: z.string().min(1, 'State is required'),
  country: z.string().min(1, 'Country is required'),
  select_event: z.string().min(1, 'Event selection is required'),
  date_time:z.date()
});

export type MeetingFormValues = z.infer<typeof meetingSchema>;
